import { Head, Link, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type FormShape = {
    name: string;
    email: string;
    password: string;
    password_confirmation: string;
};

export default function Signup() {
    const form = useForm<FormShape>({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
    });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/register');
    }

    return (
        <PublicLayout>
            <Head title="Create account" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[32px] leading-tight text-ink mb-2">Create account</h1>
                <p className="text-ink-soft text-[14px] mb-6">
                    Sign up as a consumer. Attorneys claim a profile separately.
                </p>

                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label htmlFor="signup-name" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Full name
                        </label>
                        <input
                            id="signup-name"
                            type="text"
                            autoComplete="name"
                            required
                            value={form.data.name}
                            onChange={(e) => form.setData('name', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                        {form.errors.name && <p className="text-[12px] text-red-700 mt-1">{form.errors.name}</p>}
                    </div>

                    <div>
                        <label htmlFor="signup-email" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Email
                        </label>
                        <input
                            id="signup-email"
                            type="email"
                            autoComplete="email"
                            required
                            value={form.data.email}
                            onChange={(e) => form.setData('email', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                        {form.errors.email && <p className="text-[12px] text-red-700 mt-1">{form.errors.email}</p>}
                    </div>

                    <div>
                        <label htmlFor="signup-password" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Password
                        </label>
                        <input
                            id="signup-password"
                            type="password"
                            autoComplete="new-password"
                            required
                            value={form.data.password}
                            onChange={(e) => form.setData('password', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                        {form.errors.password && <p className="text-[12px] text-red-700 mt-1">{form.errors.password}</p>}
                    </div>

                    <div>
                        <label htmlFor="signup-password-confirmation" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Confirm password
                        </label>
                        <input
                            id="signup-password-confirmation"
                            type="password"
                            autoComplete="new-password"
                            required
                            value={form.data.password_confirmation}
                            onChange={(e) => form.setData('password_confirmation', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                    </div>

                    <Btn type="submit" full loading={form.processing}>
                        Create account
                    </Btn>

                    <p className="text-[13px] text-ink-soft mt-4">
                        Already have one? <Link href="/login" className="text-ember underline">Log in</Link>.
                    </p>
                </form>
            </div>
        </PublicLayout>
    );
}
